export default {
  //   产品管理
  // 产品列表
  product_list_add: "ProductAdd",
  product_list_edit: "ProductEdit",
  product_list_del: "product_list_del",
  product_list_weight: "product_list_weight",
  product_list_status: "product_list_status",
  // 产品分类
  product_cate_list_add: "product_cate_list_add",
  product_cate_list_edit: "product_cate_list_edit",
  product_cate_list_status: "product_cate_list_status",
  product_cate_list_asso_save: "product_cate_list_asso_save",
  product_cate_list_del: "product_cate_list_del",
  // 产品属性
  product_attr_list_add: "product_attr_list_add",
  product_attr_list_edit: "product_attr_list_edit",
  product_attr_list_status: "product_attr_list_status",

  //   渠道管理
  // 渠道列表
  channel_list_add: "ChannelAdd",
  channel_list_edit: "ChannelEdit",
  channel_list_del: "channel_list_del",
  channel_list_status: "channel_list_status",
  channel_list_weight: "channel_list_weight",

  //   用户管理
  // 用户列表
  member_list_apply_list: "member_list_apply_list",
  member_list_add_allow: "member_list_add_allow",
  member_list_add_block: "member_list_add_block",
  allow_roster_list_add: "allow_roster_list_add",
  allow_roster_list_del: "allow_roster_list_del",
  deny_roster_list_add: "deny_roster_list_add",
  deny_roster_list_del: "deny_roster_list_del",

  //   运营管理
  // 广告设置
  operation_ad_add: 'operation_ad_add',
  operation_ad_edit: 'operation_ad_edit',
  operation_ad_link_config: 'operation_ad_link_config',
  operation_ad_del: 'operation_ad_del',
  operation_ad_status: 'operation_ad_status',
  // 协议合同
  oprt_doc_save: "oprt_doc_save",

  //   系统设置
  // 字典管理
  dict_list_add: "DictAddOrEdit",
  dict_list_edit: "DictAddOrEdit",
  dict_list_del: "dict_list_del",
  dict_list_enum_list: "DictEnumList",
  dict_enum_add_edit: "DictEnumAddOrEdit",

  //   权限管理
  // 管理员
  user_list_add: "UserAdd",
  user_list_edit: "UserEdit",
  user_list_del: "user_list_del",
  user_list_status: "user_list_status",
  // 角色
  role_list_add: "RoleAdd",
  role_list_edit: "RoleEdit",
  role_list_del: "role_list_del",
  role_list_menu: "role_list_menu",
  // 菜单
  menu_list_add: "MenuAdd",
  menu_list_edit: "MenuEdit",
  menu_list_del: "menu_list_del",
  // 部门
  dept_list_add: "dept_list_add",
  dept_list_edit: "dept_list_edit",
  dept_list_del: "dept_list_del",
};
